import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="memberships"
export default class extends Controller {

  changeOwnerType(e) {
    var item = e.currentTarget

    $.ajax({
      type: "GET",
      url: "/memberships/get_potential_membership_owners",
      data: {
        id: item.dataset.membership,
        kind: item.value
      },
      success: function(data) {
        if(data.status == 200) {
          var owners = JSON.parse(data.owners)

          var options = ''
          owners.forEach(function(owner){
            options += '<option value="' + owner[1] + '">' + owner[0] + '</option>'
          })

          document.getElementById('membership_owner_id').innerHTML = options
        } else {
          alert("Error getting owner list.")
        }
      }
    })
  }
  
  connect() {

  }

  
}